import {closeMenu} from './mobile-menu';
import {toArray, simulateClick} from './globals';

//declare vars
var memberDownloadButton = document.getElementById('membership-list_download-button'),
memberDownloadWrap = document.getElementById('membership-list_modal-wrap'),memberDownloadExit = document.getElementById('membership-list_modal-close'),
memberDownloadMask = document.getElementById('membership-list_modal-mask');
let previousActiveElement;

let modalFocusableNodes;
let modalFocusable;
var elFocusable = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[contenteditable]";
if (memberDownloadWrap) {
  modalFocusableNodes = memberDownloadWrap.querySelectorAll(elFocusable);
  modalFocusable = toArray(modalFocusableNodes);
}


const KEYCODE = {
  ESC: 27,
  TAB: 9,
  SHIFT: 16,
  ENTER: 13
}

export function popModal(e) {
  e.preventDefault()
  previousActiveElement = document.activeElement;
  memberDownloadWrap.classList.add('active');
  memberDownloadMask.classList.add('active');
  modalFocusable[0].focus();
  closeMenu();
  console.log(modalFocusable)
  createExitListener();
  activateKeyCheck();
}

function createExitListener() {
  
  if (memberDownloadMask) {
    memberDownloadMask.addEventListener('click', popModalExit);
  }

  memberDownloadExit.addEventListener('click', popModalExit);
  document.addEventListener('keydown', function(e) {
    if (e.which === KEYCODE.ESC) {
      popModalExit();
    }
  })
}

function activateKeyCheck() {
  document.addEventListener('keydown', function(e) {
    if (e.which == KEYCODE.TAB) {
    var currentFocus = document.activeElement,
        modalFocusableNum = modalFocusable.length,
        focusedIndex = modalFocusable.indexOf(currentFocus);
        if (e.shiftKey) {
          if (focusedIndex === 0) {
              modalFocusable[(modalFocusableNum - 1)].focus();
              e.preventDefault();
          }
          } else {
          if (focusedIndex == modalFocusableNum - 1) {
              modalFocusable[0].focus();
              e.preventDefault();
          }
        }
    }
  })
}

function popModalExit() {
  memberDownloadMask.classList.remove('active');
  memberDownloadWrap.classList.remove('active');
  previousActiveElement.focus();
}

//run modal script if exists (i.e. if not logged in)
if (memberDownloadButton != null ||memberDownloadButton != undefined) {
  memberDownloadButton.addEventListener('click', popModal);
}



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/memberlist-modal.js